import { useSelector } from 'react-redux'

export default () => useSelector(({ auth }) => auth.user.guardian_user)
